/* KEY — interactions */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Custom cursor (desktop only)
     ---------------------------------------------------------- */
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (supportsHover) {
    const dot = document.createElement('div');
    dot.className = 'cursor';
    const ring = document.createElement('div');
    ring.className = 'cursor--ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    let mouseX = -100, mouseY = -100;
    let ringX = -100, ringY = -100;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
    });

    // Ring lags behind for smooth trailing feel
    function loop() {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    }
    loop();

    // Cursor states
    document.querySelectorAll('a, button').forEach(el => {
      el.addEventListener('mouseenter', () => {
        dot.classList.add('is-hover');
        ring.classList.add('is-hover');
      });
      el.addEventListener('mouseleave', () => {
        dot.classList.remove('is-hover');
        ring.classList.remove('is-hover');
      });
    });

    document.querySelectorAll('[data-video]').forEach(el => {
      el.addEventListener('mouseenter', () => {
        const hue = getComputedStyle(el).getPropertyValue('--hue').trim();
        if (hue) dot.style.background = hue;
        dot.classList.add('is-play');
        ring.classList.add('is-play');
      });
      el.addEventListener('mouseleave', () => {
        dot.classList.remove('is-play');
        ring.classList.remove('is-play');
        dot.style.background = '';
      });
    });

    // Hide cursor when leaving window
    document.addEventListener('mouseleave', () => {
      dot.style.opacity = '0';
      ring.style.opacity = '0';
    });
    document.addEventListener('mouseenter', () => {
      dot.style.opacity = '';
      ring.style.opacity = '';
    });
  }

  /* ----------------------------------------------------------
     Thumbnail upgrade: load the highest-res variant that exists.
     Tries maxresdefault (1280×720) → sddefault (640×480),
     keeping hqdefault (480×360) as the always-present fallback.
     YouTube returns a 120×90 grey placeholder when a size is
     missing, so we accept a candidate only if it's wider than that.
     ---------------------------------------------------------- */
  document.querySelectorAll('img[data-hires]').forEach(img => {
    const id = img.getAttribute('data-hires');
    if (!id) return;
    const candidates = [
      `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`,
      `https://i.ytimg.com/vi/${id}/sddefault.jpg`
    ];
    (function tryNext(i) {
      if (i >= candidates.length) return;
      const probe = new Image();
      probe.onload = () => {
        if (probe.naturalWidth > 200) {
          img.src = candidates[i]; // success — best available wins
        } else {
          tryNext(i + 1); // placeholder returned, step down
        }
      };
      probe.onerror = () => tryNext(i + 1);
      probe.src = candidates[i];
    })(0);
  });

  /* ----------------------------------------------------------
     Header scroll state
     ---------------------------------------------------------- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 30) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------
     Scroll-triggered reveal
     ---------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('.work').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.work').forEach(el => el.classList.add('is-visible'));
  }

  /* ----------------------------------------------------------
     Hover-to-preview video tiles (muted YouTube embed on hover)
     ---------------------------------------------------------- */
  if (supportsHover) {
    document.querySelectorAll('[data-video]').forEach(article => {
      const videoId = article.getAttribute('data-video');
      if (!videoId) return;

      const mediaEl = article.querySelector('.work__media');
      let iframe = null;
      let hoverTimer = null;

      article.addEventListener('mouseenter', () => {
        hoverTimer = setTimeout(() => {
          if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.className = 'work__preview';
            iframe.allow = 'autoplay; encrypted-media';
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&loop=1&playlist=${videoId}&modestbranding=1&playsinline=1&rel=0`;
            mediaEl.appendChild(iframe);
          }
          article.classList.add('is-playing');
        }, 250); // small delay prevents firing on quick mouse-over
      });

      article.addEventListener('mouseleave', () => {
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
        article.classList.remove('is-playing');
        // Remove iframe after fade so it stops loading bandwidth
        setTimeout(() => {
          if (iframe && !article.classList.contains('is-playing')) {
            iframe.remove();
            iframe = null;
          }
        }, 600);
      });
    });
  }

  /* ----------------------------------------------------------
     Lightbox (click to open full)
     ---------------------------------------------------------- */
  const lightbox = document.querySelector('[data-lightbox]');
  if (!lightbox) return;

  const frame = lightbox.querySelector('iframe');
  const closeBtn = lightbox.querySelector('[data-lightbox-close]');

  function openLightbox(videoId) {
    frame.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lightbox.classList.remove('is-open');
    frame.src = '';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-video]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const id = el.getAttribute('data-video');
      if (id) openLightbox(id);
    });
  });

  closeBtn && closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
  });
})();
